import React from 'react'
import { FieldInputProps } from 'formik'

import { RadioGroup, Radio } from '@babylon/web-platform-ui'
import withField from '../withField'

type OptionsType = { label: string; value: string }[]

interface RadioGroupWrapperProps {
  errorMessage?: string
  field?: FieldInputProps<any>
  label?: string
  name: string
  options: OptionsType
}

const RadioGroupWrapper = ({
  field,
  name,
  options,
  label,
  errorMessage,
}: RadioGroupWrapperProps) => (
  <RadioGroup
    name={name}
    value={field?.value}
    label={label}
    errorMessage={errorMessage}
  >
    {options.map((o: any) => (
      <Radio
        {...field}
        name={name}
        key={o.label}
        label={o.label}
        id={o.label}
        value={o.value}
        onChange={(e) => {
          field?.onChange(e)
        }}
      />
    ))}
  </RadioGroup>
)

const RadioGroupWithField = withField(RadioGroupWrapper)

export default RadioGroupWithField
